<script>
import resources from './resources'

export default {
  name: 'professional-prices-index',
  mixins: [resources]
}
</script>

<template lang="pug">
page(title="Honorário por Estabelecimento e Localidade", icon="")
  .col-xs-12.content
    .container-fluid
      .row
        medibook-alert-custom(
          :show='show',
          @hide='show = false',
          message='Ainda não existe nenhum Local de Atendimento cadastrado',
          :buttonsNext='nextStepButtonAddress',
          v-if="!statusAddress")

        medibook-alert-custom(
          :show='show',
          @hide='show = false',
          message='Ainda não existe nenhum Local de Atendimento cadastrado',
          :buttonsNext='nextStepButtonAddress',
          v-if="(!statusStaff && statusAddress) && userIsCompany")

        ul.nav.nav-tabs
          li.active
            a(href='#') Listagem

          li(v-if="!statusAddress")
            a.mb-cursor-point(@click="onShow()") Cadastro

          li(v-if="statusAddress && !statusStaff && userIsCompany")
            router-link(:to="{name: 'professional.company.prices.create'}", v-if="statusAddress")
              a(href="#") Cadastro

          li(v-if="(statusStaff && statusAddress) && userIsCompany")
            router-link(:to="{name: 'professional.company.prices.create'}", v-if="!statusStaff && statusAddress")
              a(href="#") Cadastro

        .col-xs-12.white-bg.wrapper(v-if="loading")
          .row.border-bottom-light
            spinner(:show="true")

        .col-xs-12.white-bg.wrapper(v-if="!loading")
          .row.border-bottom-light
            .col-sm-offset-9.col-sm-3
              form.col-sm-12
                .form-group.busca(style='margin-top:30px;')
                  .row
                    .col-xs-9
                      input#buscar.form-control(v-model="search.generic", type='text', placeholder='Buscar Honorários')
                    .col-xs-3
                      button.search(@click.prevent="doLoadAll()")
                        span.icon 

            a.mb-cursor-point(v-if="!statusAddress", @click.prevent="onShow")
              .add-list.mb-cursor-point
                .icon-wrapper
                  span.icon 
                  .plus
                    span.icon 
                .text
                  | Novo<br>Honorário

            a.mb-cursor-point(v-if="(statusAddress && !statusStaff) && userIsCompany", @click.prevent="onShow")
              .add-list.mb-cursor-point
                .icon-wrapper
                  span.icon 
                  .plus
                    span.icon 
                .text
                  | Novo<br>Honorário

            card-add(label='Novo<br>Honorário', route='professional.company.prices.create', icon='', v-if="statusAddress && !userIsCompany")
            card-add(label='Novo<br>Honorário', route='professional.company.prices.create', icon='', v-if="(statusAddress && statusStaff) && userIsCompany")

            .list-item.white-bg.list-item.list-info(v-for="price in prices", :key="price.id")
              .row.border-bottom
                h4.col-xs-7.col-sm-8(v-tooltip="price.professional.name") {{ price.professional.name }}
                .col-xs-5.col-sm-4
                  .exclude-list(@click.prevent="doDelete(price)")
                    span.icon 
                  router-link(:to="{name: getRouterEdit, params:{id: price.id}}")
                    a(href='#')
                      .edit-list
                        span.icon 
              .list-info
                 strong {{ price.address.name || '' }}
                 br
                 span.text-italic
                   | {{ price.kind }}
                   | (R$
                   strong {{ price.value }}
                   |)
                   br
                   | Vigência {{ price.validity }}

        .pagination
          pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>



// WEBPACK FOOTER //
// src/app/professional/company/prices/index/index.vue